(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  class BlockCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.block-carousel__track');
      if (!this.track) return;

      this.slides = Array.from(this.track.children);
      this.prevButton = this.querySelector('.block-carousel__arrow--prev');
      this.nextButton = this.querySelector('.block-carousel__arrow--next');
      this.dots = Array.from(this.querySelectorAll('.block-carousel__dot'));
      this.currentIndex = 0;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      }
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      this.track.addEventListener('scroll', () => this.handleScroll(), { passive: true });

      const autoplayMs = parseInt(this.getAttribute('autoplay'), 10);
      if (autoplayMs) {
        this.startAutoplay(autoplayMs);
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay(autoplayMs));
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay(autoplayMs));
      }

      this.updateControls();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    startAutoplay(autoplayMs) {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        const nextIndex = this.currentIndex + 1 >= this.slides.length ? 0 : this.currentIndex + 1;
        this.goTo(nextIndex);
      }, autoplayMs);
    }

    stopAutoplay() {
      if (this.autoplayTimer) clearInterval(this.autoplayTimer);
    }

    goTo(index) {
      if (!this.slides.length) return;
      const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
      const target = this.slides[clamped];

      // Scroll only the carousel track itself (via scrollLeft), never the
      // page. scrollIntoView() bubbles up to ancestor scroll containers -
      // including the document - which was causing the whole page to jump
      // to the carousel's position whenever a slide changed.
      const trackRect = this.track.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const scrollLeft = this.track.scrollLeft + (targetRect.left - trackRect.left);

      this.track.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    handleScroll() {
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = requestAnimationFrame(() => {
        const trackRect = this.track.getBoundingClientRect();
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.currentIndex = closestIndex;
        this.updateControls();
      });
    }

    updateControls() {
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
      });
      if (this.prevButton) this.prevButton.disabled = this.currentIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
    }
  }

  if (!customElements.get('block-carousel')) {
    customElements.define('block-carousel', BlockCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
